import { useState, useEffect } from "react";
import { IconStar } from "../common/icon"
import { HeaderBack } from '@/components/common/header';
import _ from "lodash";
import { Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { getCookie } from "cookies-next";
import { _getAllVehicleVariant, _modelName } from "../../libraries/common";
import { VehicleImage } from "../common/image";
import { _postURL } from "../../pages/api";
import { toast } from "@/libraries/swal";
import { useRouter } from "next/router";
import { VehicleVariantModal } from "../../components/modal";
import { MyBody } from "../body/body";

export const VehicleWriteReview = (props) =>{
    const { t, device, session, params, fetchedData } = props
    const [seletedStar, setSelectedStar] = useState(5)
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(true);
    const [variantDefault, setVariantDefault] = useState(_modelName(fetchedData?.brand_name, fetchedData?.name))
    const [variantSelected, setVariantSelected] = useState()
    const router = useRouter()

    // vehicle variant modal
    const [vehicleVariantModalOpen, setVehicleVariantModalOpen] = useState(false)
    const [vehicleVariantData, setVehicleVariantData] = useState({}) // variant list by model

    const { getInputProps, onSubmit, isValid, values, setFieldError, reset, setFieldValue, clearFieldError } = useForm({
        validateInputOnChange: true,
        initialValues: {
            review: '',
        },
        validate: {
            review: (inputValue) => inputValue.length <= 0 && "Review Cannot Be Empty",
        }
    });

    const _handleClickVariantItem = async(value) => {
        setVehicleVariantModalOpen(false);
        setVariantDefault(value?.name);
        setVariantSelected(value?.variant_id);
    }

    const _subimtReview = async(value) => {
        try{
            if(_.isEmpty(userData)){
                throw ("You haven't login")
            }
            let req = {
                "review": value.review,
                "rating": seletedStar,
                "vehicle_model_id": fetchedData?.vehicle_model_id,
                "variant_id": variantSelected   // this is optional if user just want to review model
            }
            const response = await _postURL("/api/review/createUserReview", {...req});

            if(!_.isEmpty(response)){
                await toast.success("Create user review succesful")
                router.push(router.query.vehicle[0] + "/" + router.query.vehicle[1] + "/review")
            }

        } catch (error) {
            toast.error(error)
        }
    }

    useEffect(async() => {
        let user = getCookie("user") && JSON.parse(getCookie("user"));
        setUserData(user);
        try {
            await _getAllVehicleVariant(setVehicleVariantData, {
                vehicle_model_id: fetchedData?.vehicle_model_id,
            })     
            setLoading(false)
        } catch(error) {
            console.log(error)
        }   
    }, []);

    return (
        <>
            <MyBody
                t={t}
                headerComponent={<HeaderBack t={t} />}
                modalComponent={
                    <VehicleVariantModal 
                        t={t}
                        vehicleVariantModalOpen={vehicleVariantModalOpen}
                        setVehicleVariantModalOpen={setVehicleVariantModalOpen}
                        handleClickVariantItem={_handleClickVariantItem}
                        vehicleVariantData={vehicleVariantData}
                        vehicleModelActive={{image_path: fetchedData?.image_path,brand_name: fetchedData?.brand_name, model_name: fetchedData?.name}}
                        isActiveVaraintList={[]}
                        loading={loading}
                    />
                }
                showFooter={false}
            >
                <form onSubmit={onSubmit((values) => _subimtReview(values))} className="vehicleWriteReviewPage containerPadding">
                    <div className="vehicleWriteReviewPage_header">
                        <div className="vehicleWriteReviewPage_headerVehicle" style={{ flexDirection: 'column', height: 'unset' }}>
                            <div className="" style={{ display: 'flex', width: '100%', gap: '3rem' }}>
                                <div className="vehicleWriteReviewPage_headerVehicle_imageOuter">
                                    <VehicleImage 
                                        imagePath={fetchedData?.image_path}
                                    />
                                </div>
                                <div className="">
                                    <p className="fontSize_14 fontColor_lightBlue2">
                                        {fetchedData?.brand_name}
                                    </p>
                                    <p className="fontSize_14 fontWeight_semiBold">
                                        {variantDefault}
                                    </p>
                                    <p className="fontSize_12 fontColor_lightBlue2">
                                        {`${fetchedData?.body_type} | ${fetchedData?.segment}`}
                                    </p>
                                </div>
                            </div>
                            <div onClick={()=>{setVehicleVariantModalOpen(true)}} className="button_padding_md button_red2 fontSize_12 fontColor_red cursorPointer">
                                {t('select_a_variant')}
                            </div>
                        </div>
                        <div className="vehicleWriteReviewPage_rating">
                            <p className="fontSize_14 fontWeight_bold">
                                {t('ratings')}
                            </p>
                            <div className="vehicleWriteReviewPage_rating_starList">
                                {
                                    _.reduce([1,2,3,4,5], (result, value, key)=>{
                                        result.push(
                                            <div key={key} onClick={()=>{setSelectedStar(value)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer">
                                                <IconStar color={value <= seletedStar ? "#FFC327" : undefined} />
                                            </div>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                        </div>
                    </div>
                    <div className="vehicleWriteReviewPage_writeReviewContainer">
                        <p className="fontSize_14 fontWeight_bold">
                            {t('write_a_review')}
                        </p>
                        <div className="vehicleWriteReviewPage_textareaContainer"> 
                            <Textarea 
                                minRows={7}
                                maxRows={7}
                                maxLength={100}
                                placeholder={t('what_do_you_think_of_the_quality_and_appearance')}
                                classNames={{
                                    input: "vehicleWriteReviewPage_textarea_input fontSize_14",
                                    error: "fontSize_14 fontColor_red"
                                }}
                                {...getInputProps('review')}
                            />
                            <div className="vehicleWriteReviewPage_textarea_totalNumBox">
                                <p className="fontSize_14 fontColor_lightGrey3">
                                    {`${values?.review.length} / 100`}
                                </p>
                            </div>
                        </div>
                    </div>
                    <button type="submit" disabled={isValid() ? false : true} className="vehicleWriteReviewPage_submitButton primaryButtonBackground">
                        <p className="fontSize_16 fontWeight_bold fontColor_white">
                            {t('submit')}
                        </p>
                    </button>
                </form>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'>
    //                 <HeaderBack t={t} />
    //                 <form onSubmit={onSubmit((values) => _subimtReview(values))} className="vehicleWriteReviewPage containerPadding">
    //                     <div className="vehicleWriteReviewPage_header">
    //                         <div className="vehicleWriteReviewPage_headerVehicle" style={{ flexDirection: 'column', height: 'unset' }}>
    //                             <div className="" style={{ display: 'flex', width: '100%', gap: '3rem' }}>
    //                                 <div className="vehicleWriteReviewPage_headerVehicle_imageOuter">
    //                                     <VehicleImage 
    //                                         imagePath={fetchedData?.image_path}
    //                                     />
    //                                 </div>
    //                                 <div className="">
    //                                     <p className="fontSize_14 fontColor_lightBlue2">
    //                                         {fetchedData?.brand_name}
    //                                     </p>
    //                                     <p className="fontSize_14 fontWeight_semiBold">
    //                                         {variantDefault}
    //                                     </p>
    //                                     <p className="fontSize_12 fontColor_lightBlue2">
    //                                         {`${fetchedData?.body_type} | ${fetchedData?.segment}`}
    //                                     </p>
    //                                 </div>
    //                             </div>
    //                             <div onClick={()=>{setVehicleVariantModalOpen(true)}} className="button_padding_md button_red2 fontSize_12 fontColor_red cursorPointer">
    //                                 {t('select_a_variant')}
    //                             </div>
    //                         </div>
    //                         <div className="vehicleWriteReviewPage_rating">
    //                             <p className="fontSize_14 fontWeight_bold">
    //                                 {t('ratings')}
    //                             </p>
    //                             <div className="vehicleWriteReviewPage_rating_starList">
    //                                 {
    //                                     _.reduce([1,2,3,4,5], (result, value, key)=>{
    //                                         result.push(
    //                                             <div key={key} onClick={()=>{setSelectedStar(value)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer">
    //                                                 <IconStar color={value <= seletedStar ? "#FFC327" : undefined} />
    //                                             </div>
    //                                         )
    //                                         return result
    //                                     },[])
    //                                 }
    //                             </div>
    //                         </div>
    //                     </div>
    //                     <div className="vehicleWriteReviewPage_writeReviewContainer">
    //                         <p className="fontSize_14 fontWeight_bold">
    //                             {t('write_a_review')}
    //                         </p>
    //                         <div className="vehicleWriteReviewPage_textareaContainer"> 
    //                             <Textarea 
    //                                 minRows={7}
    //                                 maxRows={7}
    //                                 maxLength={100}
    //                                 placeholder={t('what_do_you_think_of_the_quality_and_appearance')}
    //                                 classNames={{
    //                                     input: "vehicleWriteReviewPage_textarea_input fontSize_14",
    //                                     error: "fontSize_14 fontColor_red"
    //                                 }}
    //                                 {...getInputProps('review')}
    //                             />
    //                             <div className="vehicleWriteReviewPage_textarea_totalNumBox">
    //                                 <p className="fontSize_14 fontColor_lightGrey3">
    //                                     {`${values?.review.length} / 100`}
    //                                 </p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                     <button type="submit" disabled={isValid() ? false : true} className="vehicleWriteReviewPage_submitButton primaryButtonBackground">
    //                         <p className="fontSize_16 fontWeight_bold fontColor_white">
    //                             {t('submit')}
    //                         </p>
    //                     </button>
    //                 </form>
    //                 <VehicleVariantModal 
    //                     t={t}
    //                     vehicleVariantModalOpen={vehicleVariantModalOpen}
    //                     setVehicleVariantModalOpen={setVehicleVariantModalOpen}
    //                     handleClickVariantItem={_handleClickVariantItem}
    //                     vehicleVariantData={vehicleVariantData}
    //                     vehicleModelActive={{image_path: fetchedData?.image_path,brand_name: fetchedData?.brand_name, model_name: fetchedData?.name}}
    //                     isActiveVaraintList={[]}
    //                     loading={loading}
    //                 />
    //             </div>
    //         </div>
    //     </>
    // )
}